// extracted by mini-css-extract-plugin
module.exports = {"sliderContainer":"SliderInput_sliderContainer__Vv-n4","blue":"SliderInput_blue__3_XD0","red":"SliderInput_red__1qaNu","yellow":"SliderInput_yellow__YM-ui"};